import { GeneratedResult } from "../lib/types";
import { cn } from "../lib/utils";
import { Loader2 } from "lucide-react";
import { Button } from "./ui/button";

interface ResultsGalleryProps {
  results: GeneratedResult[];
  selectedResult: GeneratedResult | null;
  isLoading: boolean;
  onSelect: (result: GeneratedResult) => void;
  onGoBack: () => void;
}

export function ResultsGallery({ results, selectedResult, isLoading, onSelect, onGoBack }: ResultsGalleryProps) {
  if (isLoading) {
    return (
      <div className="space-y-4">        
        <div className="flex items-center justify-center py-8">
          <div className="text-center">
            <Loader2 className="w-6 h-6 animate-spin text-primary mx-auto mb-3" />
            <p className="text-sm text-gray-600">Processing design request</p>
          </div>
        </div>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="aspect-square bg-gray-100 rounded-lg animate-pulse" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Go Back Button - Mobile friendly positioning */}
      <div className="flex justify-start mb-4">
        <Button variant="outline" size="sm" onClick={onGoBack}>
          Go Back
        </Button>
      </div>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 max-w-4xl mx-auto">
        {results.map((result) => (
          <div
            key={result.id}
            className={cn(
              "result-card",
              selectedResult?.id === result.id && "ring-2 ring-primary"
            )}
            onClick={() => onSelect(result)}
          >
            <div className="aspect-square bg-white flex items-center justify-center p-4">
              <img
                src={result.imageUrl}
                alt={`${result.furnitureType} with pattern`}
                className="w-full h-full object-contain"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = 'none';
                  target.parentElement!.innerHTML = `
                    <div class="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 rounded">
                      <div class="text-center">
                        <div class="w-20 h-20 bg-gray-200 rounded-lg mx-auto mb-2 flex items-center justify-center">
                          <span class="text-gray-400 text-xs">Preview</span>
                        </div>
                        <p class="text-xs text-gray-500">Pattern Applied</p>
                      </div>
                    </div>
                  `;
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
} 